exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer{background-color:#222;color:#fff;font-family:Source Serif Pro,serif;padding:40px calc(50% - 500px)}footer span{display:block;line-height:1.2;padding:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-548f242c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Footer.vue
// module id = 33
// module chunks = 0